/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyListModel } from '../../models/key-list-model';
import { QualificationKeyValueCodeModel } from '../../models/qualification-key-value-code-model';

export interface MasterDataQualificationLookupByKeyPost$Params {
      body?: KeyListModel
}

export function masterDataQualificationLookupByKeyPost(http: HttpClient, rootUrl: string, params?: MasterDataQualificationLookupByKeyPost$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<Array<QualificationKeyValueCodeModel>>> {
  const rb = new RequestBuilder(rootUrl, masterDataQualificationLookupByKeyPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<Array<QualificationKeyValueCodeModel>>;
    })
  );
}

masterDataQualificationLookupByKeyPost.PATH = '/MasterData/QualificationLookupByKey';
